module.exports = __webpack_public_path__ + "static/media/aaron26.741a43ab.JPG";